import isNil from "lodash/isNil";
import { makeAutoObservable } from "mobx";
import { Messages } from "core/constants";
import { ErrorCode } from "./clear-error.store.manager";

class ClearErrorStore {
    errorCodes: Array<ErrorCode> = []
    isLoading = false;
    hasError = false;
    errorMessage = "";
    isValid = false;
    smartcardNumberIsInvalid = false;

    selectedErrorCode: ErrorCode | undefined;
    smartCardNumber: string | undefined;

    constructor() {
        makeAutoObservable(this);
    }

    updateIsLoading(value: boolean) {
        this.isLoading = value;
    }

    updateHasError(value: boolean, message = Messages.apiError) {
        this.hasError = value;
        this.errorMessage = message;
    }

    updateErrorCodes(value: ErrorCode[]) {
        this.errorCodes = value;
    }

    updateSmartCardNumber(value: string | undefined) {
        this.smartCardNumber = value;
        this.smartcardNumberIsInvalid = value !== undefined && ((value?.length ?? 0) !== 10);
        this.validate();
    }

    updateSelectedErrorCode(code: string | undefined) {
        this.selectedErrorCode = this.errorCodes.find(x => x.code === code);
        this.validate();
        return this.selectedErrorCode;
    }

    validate() {
        const isSmartNumberValid = !this.smartcardNumberIsInvalid && this.smartCardNumber !== undefined;

        const isErrorCodeValid = !isNil(this.selectedErrorCode);

        this.isValid = isSmartNumberValid && isErrorCodeValid;
    }

    reset(all = true) {
        this.smartCardNumber = undefined;
        this.selectedErrorCode = undefined;
        this.isValid = false;
        this.smartcardNumberIsInvalid = false;

        if (!all) {
            return;
        }

        this.errorCodes = [];
        this.hasError = false;
        this.errorMessage = "";
        this.isLoading = false;
    }
}

export default ClearErrorStore;
